export const TABLE_CONSTANTS = {
  ACTIONCOLUMN_WIDTH: 150,
  ACTIONCOLUMN_WIDTH_BIG: 190,
  ACTIONCOLUMN_WIDTH_SMALL: 45,
  ACTIONCOLUMN_WIDTH_MEDIUM: 125,
};

export const MODEL_STATE_BOOLEAN = [
  { label: 'ACTIVO', value: true },
  { label: 'INACTIVO', value: false },
];
